<template>
  <div class="invoice">
    <div class="body container">
      <h3>invoice date: {{ todaysDate }}</h3>
      <h3 class="orange">due date: January 21, 2022</h3>
      <p class="top_text">
        This is truly an exciting time as we continue to grow and strive for
        excellence. We remain dedicated to delivering first-class service to all
        of our fans. For your convenience, listed below you will find additional
        details regarding your Washington Football Team membership and how to
        access your tickets. If you need any assistance, please feel free to
        contact us via call or text at (301) 276-6050.
      </p>
      <div class="bottom_text">
        <div>
          <h2>to access your tickets</h2>
          <p>
            Download the Washington Football Mobile App
            <strong>www.WashingtonFootball.com.com/fans/app</strong> to gain
            24-hr access to your tickets and parking via your Mobile Device.
            Visit
            <strong>www.WashingtonFootball.com/DigitalTicketing</strong>
            for more details.
          </p>
        </div>
        <div>
          <h2>GAMEDAY INFORMATION</h2>
          <p>
            <strong>Stadium Information:</strong>
            www.WashingtonFootball.com/stadium Bag
            <strong>Policy:</strong>
            www.WashingtonFootball.com/stadium/clear-bag-policy My
            <strong>Account:</strong> www.WashingtonFootball.com/MyAccount
          </p>
        </div>
      </div>
      <div class="table_wrapper">
        <div class="table_title">
          <h4>Account Information</h4>
          <div class="account_info">
            <p>
              Account Number: <span>{{ purl.accountId }}</span>
            </p>
            <p>
              Account Name: <span>{{ fullName }}</span>
            </p>
            <p>
              Account Email: <span>{{ purl.accountEmail }}</span>
            </p>
          </div>
        </div>
        <table class="table table-responsive table-borderless">
          <thead>
            <tr>
              <th scope="col">Event</th>
              <th scope="col">section</th>
              <th scope="col">row</th>
              <th scope="col">seat From</th>
              <th scope="col">seat To</th>
              <th scope="col"># of Seats</th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="account in purl.accounts" :key="account.id">
              <td>{{ account.event }}</td>
              <td>{{ account.section }}</td>
              <td>{{ account.row }}</td>
              <td>{{ account.seatFrom }}</td>
              <td>{{ account.seatTo }}</td>
              <td>{{ account.numOfSeats }}</td>
              <td>{{ account.total }}</td>
            </tr>
          </tbody>
        </table>
        <div class="account_summary">
          <div>
            <h4>Subtotal</h4>
            <h5>N/A</h5>
          </div>
          <div>
            <h4>prince george’s county admission & Amusement Tax</h4>
            <h5>N/A</h5>
          </div>
          <div>
            <h4>total due</h4>
            <h5>{{ purl.totalDue }}</h5>
          </div>
          <div>
            <h4>credit</h4>
            <h5>N/A</h5>
          </div>
          <div>
            <h4>balance due</h4>
            <h5>N/A</h5>
          </div>
        </div>
      </div>
      <h3>balance due N/A</h3>
      <h3 class="orange">due date: January 21, 2022</h3>
      <p class="upper">
        <strong>Please make check payments payable to:</strong>
        <span> Washington Football Team</span>
      </p>
      <p>Checks returned for insufficient funds are subject to a $50.00 fee.</p>
      <p>
        To view account details, visit
        <strong>www.WashingtonFootball.com/MyAccount</strong> or call
        <strong>301-276-6050</strong>.
      </p>
      <p class="footer">
        Season Ticket Members are subject to all Terms and Conditions included
        at www.www.WashingtonFootball.com.
      </p>
    </div>
  </div>
</template>


<script>
import { reactive, toRefs, computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "Invoice",
  setup() {
    const store = useStore();

    // State
    const state = reactive({
      purl: computed(() => store.getters["purl/getAccount"]),
      fullName: computed(() => store.getters["purl/getAccountFullName"]),
      todaysDate: computed(() =>
        new Date().toLocaleString("en-us", {
          month: "long",
          year: "numeric",
          day: "numeric",
        })
      ),
    });
    // console.log("state", state.accounts);
    return { ...toRefs(state), store };
  },
};
</script>

<style lang="scss" scoped>
.invoice {
  .body {
    padding: 0 2em;
    p {
      color: theme-var($--ch-theme-black) !important;
    }
    .line {
      white-space: nowrap;
      overflow: hidden;
      margin: 3em 0;
      @include media-breakpoint-down(lg) {
        margin: 1em 0;
      }
    }
    h3 {
      background: theme-var($--ch-theme-on-secondary);
      color: white;
      font-size: 24px;
      @include media-breakpoint-down(lg) {
        font-size: 18px;
      }
      font-style: normal;
      font-weight: 400;
      line-height: 35px;
      letter-spacing: -0.03em;
      text-align: center;
      text-transform: uppercase;
      padding: 0.4em 1em;
      margin: 0;
      line-height: 1;
      margin-bottom: 0.5em;
      &.orange {
        background: theme-var($--ch-theme-highlight);
      }
    }
    p.top_text {
      font-size: 16px;
      @include media-breakpoint-down(lg) {
        font-size: 12px;
        margin: 1em 0;
        line-height: 1.8em;
      }
      font-style: normal;
      font-weight: 400;
      line-height: 23px;
      letter-spacing: 0em;
      text-align: left;
      margin-block: 3em;
    }
    .table_wrapper {
      margin-block: 3em;

      @include media-breakpoint-down(xl) {
        margin-block: 1em;
      }
      .table_title {
        h4 {
          background: theme-var($--ch-theme-primary);
          margin: 0;
          font-size: 16px;
          font-style: normal;
          font-weight: 700;
          line-height: 20px;
          letter-spacing: 0px;
          text-transform: uppercase;
          padding: 15px;
        }
        .account_info {
          padding: 15px;
          p {
            margin-bottom: 0px;
            font-size: 18px;
            @include media-breakpoint-down(xl) {
              font-size: 14px;
            }
            @include media-breakpoint-down(xl) {
              font-size: 12px;
              line-height: 1.5em;
            }
            font-style: normal;
            font-weight: 700;
            line-height: 26px;
            letter-spacing: 0.15000000596046448px;
            text-align: left;

            text-transform: uppercase;
            span {
              text-transform: initial;
              padding-left: 8px;
            }
          }
        }
      }
      table {
        margin: 0;
        width: 100%;

        @include media-breakpoint-down(lg) {
          display: block;
          overflow: scroll;
        }
        thead {
          th {
            text-transform: uppercase;
            font-size: 10px;

            @include media-breakpoint-down(lg) {
              font-size: 8px;
            }
            font-style: normal;
            // font-weight: 700;
            line-height: 15px;
            letter-spacing: 1.5px;
            padding: 1em;
            text-align: center;
            &:first-child {
              text-align: left;
            }
            &:last-child {
              text-align: right;
            }
          }
        }
        tbody {
          td {
            text-transform: uppercase;
            font-size: 18px;
            @include media-breakpoint-down(xl) {
              font-size: 15px;
            }
            @include media-breakpoint-down(lg) {
              font-size: 12px;
              line-height: 1.5em;
            }
            font-style: normal;
            // font-weight: 700;
            line-height: 26px;
            letter-spacing: 0.15000000596046448px;
            text-align: left;
            padding: 0.5em;
            text-align: center;
            &:first-child {
              text-align: left;
            }
            &:last-child {
              text-align: right;
            }
          }
        }
      }
      .account_summary {
        padding: 1em 0;
        & > div {
          display: grid;
          width: 100%;
          grid-template-columns: 1fr 100px;
          h4 {
            font-size: 16px;
            @include media-breakpoint-down(xl) {
              font-size: 14px;
            }
            @include media-breakpoint-down(lg) {
              font-size: 12px;
              line-height: 1.5em;
            }
            font-style: normal;
            font-weight: 700;
            line-height: 20px;
            letter-spacing: 0px;
            text-align: right;
            text-transform: uppercase;
            padding-right: 1em;
          }
          &:last-child {
            h5 {
              // background: theme-var($--ch-theme-highlight);
            }
          }
          h5 {
            font-size: 16px;
            @include media-breakpoint-down(xl) {
              font-size: 14px;
            }
            @include media-breakpoint-down(lg) {
              font-size: 12px;
              line-height: 1.5em;
            }
            font-style: normal;
            font-weight: 700;
            line-height: 20px;
            letter-spacing: 0px;
            text-align: right;
            padding-right: 10px;
          }
        }
      }
    }
    .bottom_text {
      display: flex;
      @include media-breakpoint-down(lg) {
        flex-direction: column;
      }
      gap: 10px;
      & > div {
        background: white;
        width: 50%;
        @include media-breakpoint-down(lg) {
          width: 100%;
        }
        p {
          padding: 30px;
          @include media-breakpoint-down(lg) {
            font-size: 12px;
            padding: 10px;
          }
        }
        h2 {
          text-transform: uppercase;
          font-size: 24px;
          @include media-breakpoint-down(lg) {
            font-size: 18px;
          }
          font-style: normal;
          font-weight: 400;
          padding: 15px;
          line-height: 1;
          letter-spacing: -0.03em;
          text-align: left;
        }
      }
    }
    p {
      @include media-breakpoint-down(lg) {
        font-size: 12px;
      }
    }
    p.upper {
      text-transform: uppercase;
      margin-top: 40px;
      @include media-breakpoint-down(lg) {
        font-size: 12px;
      }
      span {
        text-transform: initial;
        @include media-breakpoint-down(lg) {
          font-size: 12px;
        }
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 26px;
        letter-spacing: 0.15000000596046448px;
        text-align: left;
      }
    }
    p.footer {
      text-transform: uppercase;
      font-size: 10px;
      font-style: normal;
      font-weight: 700;
      line-height: 15px;
      letter-spacing: 1.5px;
      text-align: center;
      margin-block: 5em;
      @include media-breakpoint-down(lg) {
        margin-block: 1em;
        font-size: 8px;
      }
    }
  }
}
</style>